import type {BookingStopData} from './Stop';
import Stop from './Stop'
import ReactModel from './ReactModel'

type SegmentModelData = Override<SegmentData, { stops: Stop[] }>

class Segment extends ReactModel<SegmentModelData> {
    constructor(data: Partial<SegmentModelData> = {}) {
        super({
            comments: '',
            date: "",
            time: "",
            duration: 0,
            stops: [
                new Stop(),
                new Stop(),
            ],
            vehicle_id: '',
            driver_id: '',
            hourly_rate: '',
            flat_rate: '',
            distance: '',
            transfer: false,
            flight: null,
            bags: null,
            pickup_time: null,
            billing_type: '',
            billed_vehicle_id: null,
            ...data,
        })
    }
}

interface Segment extends SegmentModelData {
}

export default Segment

export type SegmentBagsValue = {
    small?: number
    medium?: number
    large?: number
}

type FlightDeparture = 'DEPARTURE' | 'ARRIVAL'
type FlightDomestic = 'INTERNATIONAL' | 'DOMESTIC'

export type FlightInfo = {
    number?: string
    departure?: FlightDeparture
    domestic?: FlightDomestic
}

export type SegmentData = {
    comments: string
    date: string | null
    time: string | null
    pickup_time: string | null
    distance: StringNum
    driver_id: NullablePhpId
    duration: number
    flat_rate: StringNum
    flight: FlightInfo | null
    bags: SegmentBagsValue | null
    hourly_rate: StringNum
    id: NullablePhpId
    // key: string
    stops: BookingStopData[]
    transfer: boolean
    vehicle_id: NullablePhpId
    billing_type: string  // TODO: verify if this always exists
    billed_vehicle_id: NullablePhpId
}

/**
 * I don't know anymore. `SegmentData` and `Segment` are interchangeable. The "model" classes add a `key` when you
 * construct them which is useful in React, but otherwise it's OK to update this data back into a plain object.
 */
export type AnySegment = SegmentData | Segment
